<template>
  <div>
  	<el-tooltip :content="$t('全屏')" placement="bottom" effect="light">
		   <div :class="icon" @click='click'></div>   
		</el-tooltip>
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  props: {
    icon: {
      type: String,
      default: 'fa fa-arrows'
    },
    elId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isFullscreen: false
    }
  },
  mounted(){
    // 确保在调用以下代码前页面已经引入了 screenfull 库
    if (screenfull.isEnabled) {
      screenfull.on('change', () => {
        if (!screenfull.isFullscreen) {
          this.$emit("cancelChange",false)
        }else{
          this.$emit("cancelChange",true)
        }
      });
    }
  },
  methods: {
    click() {
    	if(this.elId){
    		let el = document.getElementById(this.elId)
    		screenfull.toggle(el);
    	}else{
    		screenfull.toggle();
    	}
    }
  }
}
</script>
